import styles from "./tooltip.module.css";

// Information needed to build the tooltip
export type InteractionData = {
    xPos: number;
    yPos: number;
    name: string;
    x: number;
    y: number;
    cost: number;
    worldConsumption: number;
    wellProduction: number;
};

type TooltipProps = {
    interactionData: InteractionData | null;
};

export const Tooltip = ({ interactionData, }: TooltipProps) => {
    if (!interactionData) {
        return null;
    }

    return (
        <div
            className={styles.tooltip}
            style={{
                left: interactionData.xPos,
                top: interactionData.yPos,
                fontSize: 24,
            }}
        >
            {interactionData.name}
            <br/>
            distance to x=y
            <br/>
            {( - (interactionData.x - interactionData.y)).toFixed(2)}
        </div>
    );
};
